<template>
  <transition name="loader-fade">
    <div
      v-if="isLoading"
      :class="{'loader-container--resized': menuOpened}"
      class="loader-container"
    >
      <div
        class="loader-overlay"
      />
      <div
        :class="[`${name}-loader`]"
      >
        <template v-if="name === 'lds'">
          <div /> <div /> <div />
        </template>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapState } from 'pinia';
import { useRootStore } from '@/stores/root';

export default {
  name: 'OverlayLoader',
  components: {
  },
  props: {
    isLoading: { type: Boolean, default: false },
    name: { type: String, default: 'lds' },
  },
  computed: {
    ...mapState(useRootStore, ['menuOpened']),
  },
  methods: {
  },
};
</script>

<style lang="scss">

.loader-fade-enter-active, .loader-fade-leave-active {
  transition: opacity .5s;
  transition-delay: .2s;
}
.loader-fade-enter-from, .loader-fade-leave-to {
  opacity: 0;
}


.loader-container{
  align-items: center;
  display: flex;
  justify-content: center;
  overflow-y: hidden;
  position: fixed;
  z-index: 400;
  height: 100%;
  width: 100%;
  @include desktop {
    &--resized{
      width: calc(100% - 260px);
    }
  }

  .loader-overlay{
    background-color: rgba(255, 255, 255, 0.479);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  .dots-loader,
  .dots-loader:before,
  .dots-loader:after {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation: dots-animation 1.8s infinite ease-in-out;
    animation: dots-animation 1.8s infinite ease-in-out;
  }
  .dots-loader {
    color: $grey-gull;
    font-size: 10px;
    margin: 80px auto;
    position: relative;
    text-indent: -9999em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
  .dots-loader:before,
  .dots-loader:after {
    content: '';
    position: absolute;
    top: 0;
  }
  .dots-loader:before {
    left: -3.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  .dots-loader:after {
    left: 3.5em;
  }
  @-webkit-keyframes dots-animation {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
  @keyframes dots-animation {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }

  .lds-loader {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-loader div {
    display: inline-block;
    position: absolute;
    left: 6px;
    width: 16px;
    background: $grey-gull;
    animation: lds-loader 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    border-radius:10px
  }
  .lds-loader div:nth-child(1) {
    left: 8px;
    animation-delay: -0.24s;
  }
  .lds-loader div:nth-child(2) {
    left: 32px;
    animation-delay: -0.12s;
  }
  .lds-loader div:nth-child(3) {
    left: 56px;
    animation-delay: 0;
  }
  @keyframes lds-loader {
    0% {
      top: 8px;
      height: 64px;
    }
    50%, 100% {
      top: 24px;
      height: 32px;
    }
  }
}


</style>

